import React from 'react';
import { Shield } from 'lucide-react';

/**
 * SecurityNotice - Reusable security and privacy notice component
 * @param {boolean} compact - If true, shows shorter version for post-download
 * @param {string} className - Additional CSS classes
 */
const SecurityNotice = ({ compact = false, className = '' }) => {
  if (compact) {
    return (
      <p className={`text-xs text-slate-500 dark:text-slate-400 flex items-center gap-1.5 mt-2 ${className}`}>
        <Shield className="w-3 h-3" />
        Your file is secure and will be automatically deleted soon.
      </p>
    );
  }

  return (
    <div className={`flex items-start gap-2.5 py-3 px-4 bg-slate-50 dark:bg-slate-800/50 rounded-lg border border-slate-200 dark:border-slate-700 ${className}`}>
      <Shield className="w-4 h-4 text-slate-400 dark:text-slate-500 mt-0.5 flex-shrink-0" />
      <p className="text-xs text-slate-500 dark:text-slate-400 leading-relaxed">
        All files are processed securely over HTTPS. We never store documents permanently — all uploads and converted files are automatically deleted after a short period. Download links are temporary and protected. Your documents remain private, secure, and inaccessible to anyone but you.
      </p>
    </div>
  );
};

export default SecurityNotice;
